/*
 * <gallery-dots> — the mobile dot navigation under the PDP gallery, plus
 * live's variant-image filtering.
 *
 * Dots: one button per non-variant slide (server rendered). The active dot
 * follows Dawn's slider ('slideChanged' on the slider-component); tapping a
 * dot scrolls the slider to its slide. Progressive enhancement: without JS the
 * slider still scrolls natively and the dots are inert.
 *
 * Variant filtering: live hides gallery media belonging to a non-selected
 * variant (classes product__media-item--variant-mobile-hide /
 * gallery-dot--variant-mobile-hide). Dawn's product-info only reorders media
 * and scrolls; it does not copy those classes on re-render. On variantChange
 * this element copies each slide's and each dot's class + selected-variant
 * attributes from the freshly rendered section, so the server stays the single
 * source of truth for what is hidden.
 */
if (!customElements.get('gallery-dots')) {
  customElements.define(
    'gallery-dots',
    class GalleryDots extends HTMLElement {
      connectedCallback() {
        this.sliderComponent = document.getElementById(this.dataset.slider);
        this.addEventListener('click', (event) => this.onDotClick(event));
        if (this.sliderComponent) {
          this.sliderComponent.addEventListener('slideChanged', (event) => this.onSlideChanged(event));
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) =>
            this.onVariantChange(event)
          );
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      get dots() {
        return Array.from(this.querySelectorAll('.gallery-dot'));
      }

      onDotClick(event) {
        const dot = event.target.closest('.gallery-dot');
        if (!dot || !this.sliderComponent) return;
        const slide = this.sliderComponent.querySelector(`li[data-media-id="${dot.dataset.target}"]`);
        const track = this.sliderComponent.querySelector('ul');
        if (!slide || !track) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      onSlideChanged(event) {
        const current = event.detail && event.detail.currentElement;
        if (!current) return;
        const mediaId = current.dataset.mediaId;
        this.dots.forEach((dot) => {
          dot.classList.toggle('is-active', dot.dataset.target === mediaId);
        });
      }

      onVariantChange(event) {
        const data = event && event.data ? event.data : {};
        if (data.sectionId !== this.dataset.sectionId || !data.html) return;

        // Slides: copy the server's visibility classes and selection state.
        const gallery = this.closest('media-gallery');
        if (gallery) {
          gallery.querySelectorAll('li[data-media-id]').forEach((slide) => {
            const source = data.html.querySelector(
              `media-gallery li[data-media-id="${slide.dataset.mediaId}"]`
            );
            if (!source) return;
            slide.setAttribute('class', source.getAttribute('class') || '');
            if (source.dataset.selectedVariantImage !== undefined) {
              slide.dataset.selectedVariantImage = source.dataset.selectedVariantImage;
            }
            if (source.style.display === 'none') {
              slide.style.display = 'none';
            } else {
              slide.style.removeProperty('display');
            }
          });
        }

        // Dots: same treatment, keyed by target.
        this.dots.forEach((dot) => {
          const source = data.html.querySelector(`.gallery-dot[data-target="${dot.dataset.target}"]`);
          if (!source) return;
          const wasActive = dot.classList.contains('is-active');
          dot.setAttribute('class', source.getAttribute('class') || '');
          dot.classList.toggle('is-active', wasActive);
        });
      }
    }
  );
}
